import { render, staticRenderFns } from "./SaveColorDialog.vue?vue&type=template&id=6df60b4f&"
import script from "./SaveColorDialog.vue?vue&type=script&lang=ts&"
export * from "./SaveColorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SaveColorDialog.vue?vue&type=style&index=0&id=6df60b4f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports